/*
 * Docked flush in the top-left corner of the live morning-meeting
 * surface. Outer edges sit on the screen edge; only the inner-facing
 * corner rounds, so the button reads as a tab nested into the corner.
 *
 * Mirrors the bottom-right KioskToggle dock so both corner tabs are
 * the same size, same glass treatment, and the same distance (zero)
 * from their respective edges.
 */
.button {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-top: 0;
  border-left: 0;
  border-radius: 0 0 24px 0;
  background: rgba(255, 255, 255, 0.32);
  backdrop-filter: blur(14px) saturate(140%);
  -webkit-backdrop-filter: blur(14px) saturate(140%);
  color: var(--token-text-primary);
  cursor: pointer;
  transition:
    background 120ms ease,
    color 120ms ease;
  box-shadow:
    0 8px 20px -10px rgba(0, 0, 0, 0.45),
    inset 0 1px 0 rgba(255, 255, 255, 0.55);
}

.button:hover {
  background: rgba(255, 255, 255, 0.55);
}
